import { gsap } from "./gsap";

export function playHeroIntro(): void {
  const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
  tl.fromTo(".hero-eyebrow", { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.6 }, 0)
    .fromTo(".hero-line-inner", { yPercent: 115 }, { yPercent: 0, duration: 1.1, stagger: 0.09 }, 0.12)
    .fromTo(".hero-sub", { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 0.8 }, 0.75)
    .fromTo(".hero-cta", { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.6, stagger: 0.08 }, 1.0)
    .fromTo(".hero-meta", { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.7 }, 1.2);
}
